<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<img
  *ngIf="isProductHome"
  class="menu-size"
  (click)="checkSideNav(target)"
  src="assets/icons/menu.svg"
  alt="menu"
/>
<img
  id="sidenavmenu"
  *ngIf="!isProductHome"
  class="menu-size"
  (click)="checkSideNav(target)"
  src="assets/icons/black-menu.svg"
  alt="menu"
/>

<ng-template #target>
  <mat-dialog-content>
    <div *ngIf="isSideNav">
      <mat-icon (click)="closeNavBar()" class="nvc-close sc-gray ws-cursor-pointer"
        >close</mat-icon
      >
      <app-nav-user (closeNav)="closeNavBar()"></app-nav-user>
      <app-side-nav-list
        (closeNavBar)="closeNavBar($event)"
      ></app-side-nav-list>
      <div
        (click)="logout()"
        *ngIf="isLoggedIn"
        class="user-logout"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <p class="notranslate" i18n>Logout</p>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>
